import React, { useEffect, Suspense } from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import lazyImages from '../../utils/lazyImages';
import { switchLangUrls } from '../../utils/switchLangUrls';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';
import SectionA from './sections/SectionA';
import SectionB from './sections/SectionB';
import SectionC from './sections/SectionC';
import SectionD from './sections/SectionD';
import SectionE from './sections/SectionE';
import './page.scss';

export function Homepage({
  data, menu, topBanner, footer, otherProps
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(lazyImages, 100);
  });

  const changeLang = (lang) => {
    switchLangUrls(lang, data, otherProps);
  };

  return (
    <main id="p-homepage">
      <SEO {...data.yoast} data={data} homepage />
      {typeof window !== 'undefined' &&
        <div>
          <Header menu={menu} content={data.acf} topBanner={topBanner} lang={data.polylang_current_lang} otherProps={otherProps} />
          <SectionA content={data.acf} />
          <SectionB data={data} content={data.acf} />
          <SectionC content={data.acf} />
          <SectionD content={data.acf} />
          <SectionE content={data} />
          <Footer footer={footer} langs={data} changeLang={(e) => changeLang(e, data, otherProps)} lang={data.polylang_current_lang} />
        </div>}
    </main>
  );
}

const Page = (props) => {
  const { wordpressPage: page, allWordpressPage: headerAndFooter, wordpressMenusMenusItems: menu } = props.data;
  return (
    <Layout props={props}>
      <Homepage data={page} menu={menu} topBanner={headerAndFooter} footer={headerAndFooter} otherProps={{ ...props }} />
    </Layout>
  );
};

Page.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Page;

export const pageQuery = graphql`
  query Homepage($lang: String, $id: Int, $menuLangName: String) {
    wordpressMenusMenusItems(
      name: {eq: $menuLangName}
    ) {
      items {
        url
        title
        classes
      }
      name
    }
    allWordpressPage {
      edges {
        node {
          polylang_current_lang
          acf {
            head_script
            top_banner_text_color
            top_banner_message
            top_banner_background_color
            show_top_banner
            footer_col_1
            footer_col_2
            footer_col_3
            footer_col_4
            footer_horizontal_menu
            store_google_url
            store_apple_url
            store_apple_image {
              source_url
            }
            store_google_image {
              source_url
            }
            social_media_item_page {
              image {
                source_url
              }
              url
            }
          }
        }
      }
    }
    wordpressPage(
      wordpress_id: {eq: $id}
      polylang_current_lang: { eq: $lang }
    ) {
      title
      slug
      polylang_current_lang
      yoast {
        metadesc
        title
      }
      polylang_translations {
        slug
        polylang_current_lang
      }
      acf {
        featured_thumbnail {
          source_url
        }
        intro_title
        intro_subtitle
        intro_video {
          source_url
        }
        intro_image {
          source_url
        }
        stores_title
        intro_store_apple_url
        intro_store_google_url
        store_apple_image {
          source_url
        }
        store_google_image {
          source_url
        }
        offer_title
        offer_item_page {
          title
          button_url
          button_title
          image {
            source_url
          }
          description
        }
        numbers_text_3
        numbers_text_2
        numbers_text_1
        number_item_3
        number_item_2
        number_item_1
        referents_title
        referents_items_page {
          url
          image {
            source_url
          }
        }
        referents_quotes_page {
          author
          quote
        }
        events_title
        event_item_page {
          article_category
          article_date
          author
          author_position
          background_image {
            source_url
          }
          profile_picture {
            source_url
          }
          show_store
          description
          button_title
          title
          url
          type
        }
      }
    }
  }
`;
